package com.essntl.core.twilio.data

import com.essntl.config.EssntlConfig
import com.essntl.core.network.IO
import com.essntl.core.twilio.domain.TwilioClient
import com.essntl.core.utils.error.BadRequestException
import io.ktor.client.HttpClient
import io.ktor.client.request.basicAuth
import io.ktor.client.request.forms.submitForm
import io.ktor.client.request.header
import io.ktor.http.*
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext

internal class TwilioClientImpl(
    private val httpClient: HttpClient,
) : TwilioClient {
    override suspend fun sendSms(
        to: String,
        message: String,
    ): Result<Unit> = sendMessage(
        to = "sms:+$to",
        from = "sms:+$FROM_PHONE",
        message = message,
    )

    private suspend fun sendMessage(
        to: String,
        from: String,
        message: String,
    ): Result<Unit> =
        withContext(Dispatchers.IO) {
            val response = httpClient.submitForm(
                url = BASE_URL + "/${EssntlConfig.twilioAccountId}/Messages.json",
                formParameters =
                parameters {
                    append("To", to)
                    append("From", from)
                    append("Body", message)
                },
            ) {
                header(HttpHeaders.ContentType, ContentType.Application.FormUrlEncoded)
                basicAuth(EssntlConfig.twilioAccountId, EssntlConfig.twilioPassword)
            }

            if (response.status.isSuccess())
                Result.success(Unit)
            else
                Result.failure(BadRequestException())
        }

    companion object {
        private const val BASE_URL = "https://api.twilio.com/2010-04-01/Accounts"
        private const val FROM_PHONE = "447554587593"
    }
}
